module.exports = __webpack_public_path__ + "img/background_green.79507813.png";